import { render, staticRenderFns } from "./ThumbsUpIcon.vue?vue&type=template&id=445d6ad8&"
import script from "./ThumbsUpIcon.vue?vue&type=script&lang=js&"
export * from "./ThumbsUpIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports